<template>
  <div>
    <div :class="tabType ? 'tab-container' : 'tab-container-card'" :style="!showBottomBorder && tabType ? 'border-bottom: none;' : 'border-radius: 8px'">
      <!--标题区-->
      <div class="tab-title">
        <div class="title" v-if="tabType">
          <span class="border-left-primary-color title-span">{{ title }}</span>
          <slot name="titleTips"></slot>
        </div>
        <div class="tabs" v-if="!hideTabs">
          <div class="tabs-box" ref="tabsBox">
            <div class="tabs-wrap" ref="tabsWrap">
              <template v-for="(tab, idx) in tabs">
                <div
                  class="tab-item"
                  :class="idx === tabs.length - 1 || tab.length === 1 ? 'tab-item-last-children': ''"
                  :key="tab.name"
                  @click="tabItemClick(idx)"
                  ref="tabItem"
                >
                  <slot
                    :name="'tab_' + tab.name"
                    :selected="idx === selectIdx"
                  >
                    <span
                      class="tab-item-text"
                      :class="{'font-color-primary': idx === selectIdx}"
                    >
                      <slot :name="tab.label">{{ tab.label }}</slot>
                      <span class="tab-badge" v-if="countMap && countMap[tab.name]">
                        {{countMap[tab.name]}}
                      </span>
                      <span class="tab-badge" v-if="tab.count">
                        {{tab.count}}
                      </span>
                    </span>
                  </slot>
                </div>
              </template>
              <div
                class="tabs-line-action font-color-primary"
                ref="tabsLine"
              ></div>
            </div>
          </div>
        </div>
        <!--下拉选项-->
        <div class="dropdown" v-if="showDropdown">
          <el-dropdown class="el-dropdown-wrap" trigger="click" @command="tabItemClick" @visible-change="tabIconClick">
            <div :class="[{'dropdown-link': true},{'rotate90': tabRotate}]" >
              <i class="iconfont icon-tongyongxiala1"/>
            </div>
            <el-dropdown-menu class="dropdown-menu" slot="dropdown" v-scrollbarPrettify>
              <template v-for="(tab, idx) in tabs">
                <el-dropdown-item
                  :key="idx"
                  :command="idx"
                  class="tab-dropdown-item"
                >
                  <p class="tab-item-text" :class="{'font-color-primary': idx === selectIdx}">
                    {{tab.label}}
                  </p>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!--占位符-->
      <!-- <div class="placeholder-line"></div> -->
    </div>
    <!--tab切换显示内容区-->
    <div :class="`tab-content tab-content-${type}`">
      <slot/>
    </div>
  </div>
</template>

<script>
  import {tabsProps} from './index.js'
  export default {
    name: 'tabs',
    props: tabsProps,
    data () {
      return {
        tabs: [],
        currentName: '',
        isFirstUpdate: true,
        showDropdown: false,
        selectIdx: -1,
        tabRotate: false
      }
    },
    mounted () {
      const {tab} = (this.$route && this.$route.query) || {}
      this.currentName = tab || this.activeTab
      if (!this.currentName) {
        this.updateTabs()
      }
      window.onresize = () => {
        this.countScrollWidth()
      }

      // 国际化 后面改了tabitem的label，但是不更新 以下方案解决
      this.$on('updateTabPaneLabel', (label) => {
        const slotPane = this.$slots.default.find(vnode => vnode.tag &&
          vnode.componentOptions &&
          vnode.componentOptions.Ctor.options.name === 'tab-item' &&
          vnode.componentOptions.propsData.name === label
        )
        if (slotPane) {
          const idx = this.tabs.findIndex(item => item.name === slotPane.key)
          idx >= 0 && this.$set(this.tabs[idx], 'label', slotPane.componentOptions.propsData.label)
          idx >= 0 && this.$set(this.tabs[idx], 'count', slotPane.componentOptions.propsData?.count || '')
        }
      })
    },
    model: {
      prop: 'activeTab',
      event: 'change'
    },
    watch: {
      currentName (key) {
        this.updateTabs()
        this.$nextTick(() => {
          let idx = this.tabs.findIndex(v => v.name === key)
          if (idx < 0) {
            idx = this.tabs.findIndex(v => v.name === this.activeTab)
          }
          this.changeTabIdx(idx)
        })
      },
      selectIdx (idx) {
        const {name} = this.tabs[idx]
        this.$emit('change', name)
      },
      activeTab (val) {
        this.currentName = val
      }
    },
    computed: {
      tabType () {
        return this.type === 'ordinary'
      }
    },
    methods: {
      /**
       * 更新导航的选中线条的位置
       */
      updateLinePosition () {
        if (this.selectIdx === -1 || !this.$refs.tabItem) {
          return
        }

        const $tabItem = this.$refs.tabItem[this.selectIdx]
        const $tabsLine = this.$refs.tabsLine

        // dom 加载完成计算选中线的位置
        if ($tabItem) {
          $tabsLine.style.width = `${$tabItem.offsetWidth}px`
          $tabsLine.style.transform = `translateX(${$tabItem.offsetLeft}px)`
        }
        this.countScrollWidth()
      },
      /**
       * 更新导航的列表 根据tab-pane的数量去更新
       */
      updateTabs () {
        if (this.$slots.default) {
          const slotPane = this.$slots.default.filter(vnode => vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'tab-item')
          if (this.tabs.length !== slotPane.length) {
            this.tabs = slotPane.map(({componentOptions, key}) => {
              return {
                ...componentOptions.propsData,
                key
              }
            })
          }
          if (this.tabs.length && (!this.activeTab || !this.tabs.find(v => v.name === this.activeTab))) {
            this.activeTab = this.tabs[0].name
            this.changeTabIdx(0)
          }
          this.updateLinePosition()
        }
      },
      // 切换tab事件
      tabItemClick (idx) {
        const pane = this.tabs[idx]
        const name = pane.name
        if (this.currentName === name) return
        // tab切换 清空query中存储的搜索条件
        if (this.$route.query.c) {
          if (this.changeTabReserveQuery) {
            let newQuery = Object.assign({}, JSON.parse(this.$route.query.c), {
              page: 1,
              pageSize: 10
            })
            this.$route.query.c = JSON.stringify(newQuery)
          } else {
            this.$route.query.c = null
          }
        }
        if (this.isHaveTab) {
          const query = this.$route.query
          this.$router.push({
            path: this.$route.path,
            query: Object.assign({}, query, {tab: name})
          })
          this.$route.query.tab = name
        }
        this.$emit('tab-click', name)
        this.$emit('change', name)
        this.changeTabIdx(idx)
      },
      // 修改当前切换的tabs的下标
      changeTabIdx (idx = 0) {
        if (this.selectIdx === idx) {
          return
        }
        this.activeTab = this.tabs[idx].name
        this.currentName = this.tabs[idx].name
        this.selectIdx = idx
      },
      /**
       * 选中线条的位置更新后同步更新线条的宽度
       */
      countScrollWidth () {
        if (this.selectIdx === -1 || !this.$refs.tabItem) {
          return
        }
        const $tabsBox = this.$refs.tabsBox
        const $tabsWrap = this.$refs.tabsWrap
        const $tabItem = this.$refs.tabItem[this.selectIdx]
        // 盒子的宽度
        const tabsBoxWidth = $tabsBox.clientWidth
        const tabsWrapWidth = $tabsWrap.clientWidth
        const tabItemWidth = $tabItem ? $tabItem.clientWidth : 0
        const tabItemLeft = $tabItem ? $tabItem.offsetLeft : 0

        // 计算横向滚动距离
        let scrollLeft = (tabItemWidth / 2) + tabItemLeft - (tabsBoxWidth / 2)

        if (scrollLeft < 0) {
          scrollLeft = 0
        }

        if (scrollLeft > tabsWrapWidth - tabsBoxWidth) {
          scrollLeft = tabsWrapWidth - tabsBoxWidth
        }

        this.showDropdown = tabsBoxWidth < tabsWrapWidth
        $tabsWrap.style.left = `-${scrollLeft}px`
      },
      tabIconClick (data) {
        this.tabRotate = data
      }
    },
    filters: {
      countOverflow (count) {
        if (count > 99) {
          return '99+'
        }
        return count
      }
    },
    updated () {
      this.updateTabs()
      if (this.isFirstUpdate) {
        this.isFirstUpdate = false
        const idx = this.tabs.findIndex(v => (v.name === this.activeTab) || (v.name === this.currentName))
        if (idx >= 0) {
          this.changeTabIdx(idx === -1 ? 0 : idx)
        }
      }
    },
    destroyed () {
      window.onresize = null
    }
  }
</script>

<style scoped lang="scss">
  .dropdown-menu {
    max-height: 384px;
    overflow: auto;
  }
  .tab-dropdown-item {
    padding: 0 32px 0 16px;
  }
  .tab-item-text {
    text-align: center;
    white-space: nowrap;
    color: #242F57;
  }

  .tab-content-card {
    //border: 1px solid #D6DFFF;
    box-shadow: 0 0 15px rgba(57, 121, 201, 0.15);
    border-radius: 0 8px 8px 8px;
    background: #fff;
    margin-bottom: 8px;
    //margin-top: 8px;
  }

  .tab-container {
    background: #fff;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 8px rgba(57, 121, 201, 0.14);
    border: 1px solid #D6DFFF;
    //margin-top: 8px;
    .tabs {
      height: 45px;
      line-height: 45px
    }

    .tabs-wrap {
      line-height: 45px;
    }

    .tab-item {
      height: 100%;
      margin: 0 20px;
      font-weight: 500;
    }
  }

  .tab-container-card {
    .tabs {
      height: 40px;
      line-height: 40px
    }

    .tabs-wrap {
      line-height: 22px;
    }

    .tabs-wrap .tab-item:first-child {
      border-left: 1px solid #E3E7EA;
      border-top-left-radius: 8px;
    }
    .tabs-wrap .tab-item.tab-item-last-children {
      border-top-right-radius: 8px;
    }

    .tab-item {
      padding: 9px 20px;
      background: #fff;
      border-right: 1px solid #E3E7EA;
      border-top: 1px solid #E3E7EA;
      font-weight: 400;
    }
  }

  .tab-container, .tab-container-card {
    width: 100%;
    box-sizing: border-box;

    .tab-item-text {
      position: relative;
    }

    // .tab-badge {
    //   position: absolute;
    //   background: #EB5E44;
    //   min-width: 18px;
    //   font-size: 12px;
    //   transform: scale(0.8);
    //   padding: 2px 2px;
    //   right: -18px;
    //   bottom: 8px;
    //   border-radius: 9px;
    //   color: #fff;
    //   text-align: center;
    //   line-height: 14px;
    //   font-weight: 300;
    // }
    .tab-badge {
      color: #97A0C3;
      font-size: 14px;
      margin-left: 4px;
      font-weight: 500;
    }
    .tab-item {
      position: relative;
      display: inline-block;
      font-size: 14px;
      vertical-align: middle;
      cursor: pointer;
      user-select: none;
    }

    .tabs-box {
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      overflow: hidden;

      .tabs-wrap {
        position: absolute;
        min-width: 100%;
        height: 100%;
        white-space: nowrap;
        box-sizing: border-box;
        transition: all .3s;

        .tabs-line-action {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          height: 2px;
          background: currentColor;
          transition: all .3s;
          z-index: 1;
        }
      }
    }

    .tab-title {
      font-size: 18px;
      color: #303030;
      display: flex;
      align-content: center;
      width: 100%;

      .title {
        height: 45px;
        line-height: 45px;
        margin-right: 30px;
        .title-span {
          line-height: 1;
          font-size: 18px;
          display: inline-block;
          border-left: 4px solid;
          padding-left: 8px;
          font-weight: 500;
          color: #242F57;
          letter-spacing: 0;
          vertical-align: middle;
          margin-left: 24px;
        }
      }

      .tabs {
        flex: 1;
        position: relative;
        display: inline-block;
        vertical-align: middle;
        box-sizing: border-box;
      }

      ::v-deep .dropdown {
        position: relative;
        .rotate90 {
          transform: rotate(180deg);
          .icon-tongyongxiala1 {
            top: -2px !important;
          }
        }
        .dropdown-link {
          display: inline-block;
          width: 60px;
          height: 45px;
          text-align: center;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top-right-radius: 8px;
          cursor: pointer;
          .icon-tongyongxiala1 {
            font-size: 18px;
            position: relative;
            top: 4px;
            color: #97A0C3;
          }
        }
      }
    }

    .placeholder-line {
      display: block;
      height: 10px;
      background-color: #eceff2;
      margin-right: -10px;
    }
  }
</style>
